import { StandardSnack } from '@components/snackbar';
import { CloseIcon } from '@sketchnote/icons';
import { LoaderXs } from '@sketchnote/shared-components';
import { useRouter } from 'next/router';
import * as React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { API, endpoints } from 'src/api';
import { useLayout } from 'src/shared/hooks/use-layout';

import { EmptyNotification } from './components/empty-notification';
import { NotificationTemplate } from './components/notification-template';
import { NotificationProps } from './types';

const { useState, useEffect } = React;

export const Notifications = (): JSX.Element => {
  const [notificationData, setNotificationData] = useState<NotificationProps[]>([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [notificationLoading] = useState(false);
  const [markAllAsRead, setMarkAllAsRead] = useState(false);
  const { onCloseNotifications } = useLayout();
  const { setNotificationCount } = useLayout();
  const router = useRouter();
  const getNotificationData = async (page, reset = false) => {
    // setNotificationLoading(true);
    endpoints.notifications.page = page;
    const data = await API.get(endpoints.notifications.url);

    if (data?.data?.success) {
      // setNotificationLoading(false);

      setNotificationData((prev) => {
        if (prev.length === 0 || reset) {
          prev = data?.data?.data;
        } else {
          prev.push(...data?.data?.data);
          prev = prev.map((x) => x);
        }
        return prev;
      });
      if (data?.data?.data.length === 0) {
        setHasMore(false);
      }
    }
  };

  const handleFetchNotifications = () => {
    getNotificationData(page + 1);
    setPage(page + 1);
  };

  useEffect(() => {
    getNotificationData(0);
  }, []);

  async function handleClickNotification(item: NotificationProps) {
    const response = await API.put(endpoints.notifications.markAsRead, { id: item._id });
    const urlToGo = item.url;
    router.push(urlToGo);
    onCloseNotifications();
  }

  async function handleMarkAllAsRead() {
    await API.put(endpoints.readNotificationAll.url);
    setMarkAllAsRead(true);
    setNotificationCount(0);
    getNotificationData(page, true);
  }

  return (
    <div className="flex flex-col overflow-hidden">
      <div
        className="flex px-16 py-8 justify-between text-sm"
        style={{ backgroundColor: '#F6F8FA', borderBottom: '1px solid #E2E4E9' }}
      >
        <p className="font-medium">Notifications</p>

        <div className="flex">
          <button onClick={handleMarkAllAsRead} className=" text-blue-500 mr-12">
            Mark all read
          </button>
          <button onClick={onCloseNotifications} className="border rounded-md px-4 text-gray-600">
            <CloseIcon className="text-xs" />
          </button>
        </div>
      </div>
      <div id="scrollableDiv" className="overflow-y-scroll">
        {!notificationLoading && notificationData.length > 0 ? (
          <InfiniteScroll
            dataLength={notificationData.length}
            next={handleFetchNotifications}
            hasMore={hasMore}
            scrollableTarget="scrollableDiv"
            loader={
              <div>
                <LoaderXs className="mx-auto text-xss m-10" />
              </div>
            }
            endMessage={
              <div className="flex items-center justify-center pt-10 pb-10">
                <StandardSnack text="Whew! You’ve seen all your notifications!" />
              </div>
            }
          >
            {notificationData?.map((item, index) => {
              return (
                <div key={index} className="m-8">
                  <NotificationTemplate
                    item={item}
                    markAllAsRead={markAllAsRead}
                    onClickNotification={handleClickNotification}
                  />{' '}
                </div>
              );
            })}
          </InfiniteScroll>
        ) : null}
      </div>
      {!notificationLoading && notificationData.length === 0 ? <EmptyNotification /> : null}
    </div>
  );
};
